module.exports = __webpack_public_path__ + "static/media/hands.d0552269.mp4";